module.exports = __webpack_public_path__ + "static/img/bigbackground.60a6aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bigbackground.png
// module id = a/ie
// module chunks = 1